import gsap from 'gsap'
import { useRef } from 'react'
import { useDelay, useView } from '@10000/react'
import { useGSAP } from '@gsap/react'
import { Box, H1, H4, Meter } from '../../widgets'
import { assetUrl } from '../../../utilities.js'
import { questions } from '../../../lookups'
import { AnswerCards, usePracticeWheel } from '../common'
import { SplashScreen } from '../../layout/index.js'

export const Consensus = () => {
  const { question, consensusAnswers, teamSize, playersAnswered } = useView('squiz')
  const splashComplete = useDelay(5000)
  const { hide } = usePracticeWheel()

  const questionContainer = useRef()
  const questionText = useRef()
  const lockedInCount = useRef()
  const meter = useRef()

  const value = consensusAnswers[0]?.answer
  const squizQuestion = questions[question]?.consensus || questions[question]

  useGSAP(() => {
    hide()
    if(splashComplete) {
      gsap.timeline()
        .to(meter.current, { y: -480 })
        .to(questionText.current, { fontSize: 55, textAlign: 'left' }, '<')
        .to(questionContainer.current, { top: 120, left: 120, maxWidth: 1100, transform: 'translateX(0)' }, '<')
        .to(lockedInCount.current, { opacity: 1 })
    }
  }, [splashComplete])

  return (
    <Box container fullWidth fullHeight overflow="hidden">
      <Box
        column
        alignItems="flex-start"
        ref={questionContainer}
        position="absolute"
        maxWidth={1100}
        gap={32}
        zIndex={1}
        style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
      >
        <H1 ref={questionText}>
          {squizQuestion?.question}
        </H1>
        <H4 ref={lockedInCount} opacity={0} uppercase>
          {playersAnswered}/{teamSize} team members locked in
        </H4>
      </Box>

      <Box position="absolute" width={640} right={40} top={120} opacity={splashComplete ? 1 : 0} transition={0.5}>
        <AnswerCards />
      </Box>

      <Box ref={meter} position="absolute" width={960} bottom={-480} left={120}>
        <Meter
          value={value}
          answers={consensusAnswers}
          lineHeight={32}
          avatarSize="medium"
        />
      </Box>

      <SplashScreen
        background={`var(--red) url(${assetUrl('gifs/little-eyes.gif')}) center / cover`}
        open={!splashComplete}
      >
        <H1>Let&apos;s start<br/>consensus mode!</H1>
      </SplashScreen>
    </Box>
  )
}
